var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-card',[_c('b-row',[_c('b-col',[_c('b-tabs',[(_vm.checkRoles('configuration', 'LogList'))?_c('b-tab',{attrs:{"title":_vm.$t('menu.logs.list')}},[_c('LogList')],1):_vm._e(),(_vm.checkRoles('configuration', 'DownloadData'))?_c('b-tab',{attrs:{"title":_vm.$t('menu.downloaddata.list')}},[_c('DownloadData')],1):_vm._e()],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }